export const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.84966 16.0001C3.84966 9.28989 9.2894 3.85015 15.9997 3.85015C22.7099 3.85015 28.1497 9.28989 28.1497 16.0001C28.1497 17.32 28.0398 18.3425 27.7283 19.0828C27.4673 19.703 27.0626 20.1506 26.1973 20.3978C25.6118 20.5651 24.9943 20.4594 24.6105 20.1074C24.3211 19.8419 23.8411 19.1339 23.9004 17.4211C23.9828 16.9599 24.0258 16.485 24.0258 16.0001C24.0258 11.5672 20.4323 7.97363 15.9994 7.97363C11.5665 7.97363 7.9729 11.5672 7.9729 16.0001C7.9729 20.433 11.5665 24.0266 15.9994 24.0266C18.059 24.0266 19.9375 23.2508 21.3585 21.9755C21.5782 22.29 21.8286 22.5765 22.1094 22.834C23.6815 24.2761 25.7404 24.3764 27.2138 23.9554C29.2309 23.3791 30.4732 22.0994 31.1387 20.5177C31.7537 19.0561 31.8497 17.4022 31.8497 16.0001C31.8497 7.24643 24.7534 0.150146 15.9997 0.150146C7.24594 0.150146 0.149658 7.24643 0.149658 16.0001C0.149658 24.7539 7.24594 31.8501 15.9997 31.8501C19.0783 31.8501 21.9572 30.9705 24.3922 29.4481L22.4307 26.3108C20.5667 27.4763 18.3647 28.1501 15.9997 28.1501C9.2894 28.1501 3.84966 22.7104 3.84966 16.0001ZM20.3244 15.8858C20.2754 16.2525 20.2407 16.6089 20.2202 16.9546C19.7856 18.8848 18.0608 20.3266 15.9994 20.3266C13.6099 20.3266 11.6729 18.3895 11.6729 16.0001C11.6729 13.6107 13.6099 11.6736 15.9994 11.6736C18.3506 11.6736 20.2638 13.5492 20.3244 15.8858Z"
      fill="url(#paint0_linear_10243_790)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10243_790"
        x1="22.5002"
        y1="29.5"
        x2="3.50024"
        y2="-3.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E79723" />
        <stop offset="1" stopColor="#F0C338" />
      </linearGradient>
    </defs>
  </svg>
)
